/**
 * Global utilities for handling header spacing
 * These functions can be used by multiple components
 */

window.headerSpacingUtils = {
    /**
   * Get the heights of the header and announcement bar
   * @returns {Object} Object with the calculated heights
   */

  getHeaderHeights() {
    const header = document.querySelector('hh-header')
    const announcement = document.querySelector('#announcement-bar')

    const headerHeight = header?.getBoundingClientRect().height || 0
    const announcementHeight = announcement?.getBoundingClientRect().height || 0

    return {
      headerHeight,
      announcementHeight,
      totalHeight: headerHeight + announcementHeight
    }
  },

  /**
   * Update the CSS variables with the heights of the header
   */
  updateCSSVariables() {
    const { headerHeight, announcementHeight } = this.getHeaderHeights()

    const root = document.querySelector(':root')
    if (root) {
      root.style.setProperty('--hh-announcement-height', `${announcementHeight}px`)
      root.style.setProperty('--hh-header-height', `${headerHeight}px`)
    }
  },

    /**
   * Adjust the padding of the main to avoid the sticky header from overlapping
   * @param {boolean} skipIndex - If true, no apply padding on the index page
   */
  setMainPadding(skipIndex = false) {
    const main = document.querySelector('main')
    if (!main) return

    const { headerHeight } = this.getHeaderHeights()
    const isSticky = !!document.querySelector('hh-sticky-header')

    // No apply padding on index or 404
    if (skipIndex || document.body.classList.contains('template-index') || document.body.classList.contains('template-404')) {
      main.style.paddingTop = '0px'
    } else if (isSticky) {
      // Only apply padding if the header is sticky (only header height)
      main.style.paddingTop = `${headerHeight}px`
    } else {
      // If not sticky, no apply padding
      main.style.paddingTop = '0px'
    }
  },

  /**
   * Complete function that updates both the CSS variables and the padding of the main
   * @param {boolean} skipIndex - If true, no apply padding on the index page
   */
  updateHeaderSpacing(skipIndex = false) {
    this.updateCSSVariables()
    this.setMainPadding(skipIndex)
  }
}

// Initialize when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.headerSpacingUtils.updateHeaderSpacing()
  })
} else {
  window.headerSpacingUtils.updateHeaderSpacing()
}
